// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__y4zwe","tab":"Tabs_tab__dL0H5","tabActive":"Tabs_tabActive__v5pyi"};